import { View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { HrViewModel } from "./hr-viewModel"

export class HrView extends FormBuilderComponentView<HrViewModel>{
    GetViewUniqueId(): string {
        return "V-EBCEBEC3-2DEE-4260-B2B0-383FF759E898"
    }
    loadHtml(): string {
        let element = require('./hr.html').default;
        let style = require('./hr.less');
        return element;
    }
    constructor() {
       super();
    }
    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
}
